import envConfig, { AppRegionUnion } from './env-config'

const regionsRes = {
  cn: {
    regionText: 'cn',
    otherRegionResKey: 'global',
    regionLink: 'https://clinic.pingcap.com.cn',
    promotionMsg: 'Clinic.cn for China customers is here!',

    servicesAgreementLink:
      'https://clinic-docs.vercel.app/docs/services-agreement',
    privacyLink: 'https://pingcap.com/zh/privacy-policy',
    introLink: 'https://docs.pingcap.com/zh/tidb/stable/clinic-introduction',
    quickStartLink:
      'https://docs.pingcap.com/zh/tidb/stable/quick-start-with-clinic',
    releaseNoteLink: 'https://clinic-docs-en.vercel.app/docs/release-note',
    uploadByTiUPLink:
      'https://docs.pingcap.com/zh/tidb/stable/clinic-user-guide-for-tiup',
    uploadByOperatorLink:
      'https://docs.pingcap.com/zh/tidb-in-kubernetes/stable/clinic-user-guide',
    executeAPIPathBase:
      'https://hryp6zy52f.execute-api.cn-north-1.amazonaws.com.cn'
  },
  global: {
    regionText: 'global',
    otherRegionResKey: 'cn',
    regionLink: 'https://clinic.pingcap.com',
    promotionMsg: 'Clinic located in US for global users is here!',

    servicesAgreementLink:
      'https://clinic-docs-en.vercel.app/docs/services-agreement',
    privacyLink: 'https://en.pingcap.com/privacy-policy/',
    introLink: 'https://docs.pingcap.com/tidb/stable/clinic-introduction',
    quickStartLink:
      'https://docs.pingcap.com/tidb/stable/quick-start-with-clinic',
    releaseNoteLink: 'https://clinic-docs-en.vercel.app/docs/release-note',
    uploadByTiUPLink:
      'https://docs.pingcap.com/tidb/stable/clinic-user-guide-for-tiup',
    uploadByOperatorLink:
      'https://docs.pingcap.com/tidb-in-kubernetes/stable/clinic-user-guide',
    executeAPIPathBase: 'https://ob9wsi99ul.execute-api.us-west-2.amazonaws.com'
  }
}

export function getRegionRes() {
  return regionsRes[envConfig.appRegion]
}

export function getOtherRegionRes() {
  return regionsRes[getRegionRes().otherRegionResKey as AppRegionUnion]
}
